import React, { useState } from 'react'

import { Auth } from '../../amplify'
import { useAuthScreenStyles } from './authScreenStyles'

export default function RequireNewPassword({ user, onComplete, onCancel }) {
  const classes = useAuthScreenStyles()
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async event => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await Auth.completeNewPassword(user, password)
      onComplete()
    } catch (err) {
      setError(err.message || 'Could not set a new password.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <img className={classes.logo} src="/assets/icons/blue-logo.svg" alt="Civic Champs" />
        <h3 className={classes.header}>Change Password</h3>
        <form onSubmit={handleSubmit}>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="admin-new-password">
              New Password *
            </label>
            <input
              id="admin-new-password"
              className={classes.input}
              type="password"
              placeholder="Enter your new password"
              autoComplete="new-password"
              autoFocus
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          {error && <p className={classes.error}>{error}</p>}
          <div className={classes.footer}>
            <span className={classes.footerSecondary}>
              <button type="button" className={classes.link} onClick={onCancel}>
                Back to Sign In
              </button>
            </span>
            <button type="submit" className={classes.submit} disabled={loading}>
              Change
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
